// extracted by mini-css-extract-plugin
export default {"supplierslistmain":"SuppliersList_supplierslistmain__nJcK7","supplierslisttablewrapper":"SuppliersList_supplierslisttablewrapper__owSqG"};